const initializeMenuDrawerStoreSp = () => {
  const el = document.querySelector(".fs-menu-drawer-store-sp");
  if (!el) {
    return;
  }
  addEvents(el);
};

const addEvents = (el) => {
  el.querySelectorAll(".fs-menu-drawer-store-sp nav .fs-nav-item.has-submenu").forEach((navItem) => {
    const button = navItem.querySelector("button");
    button.addEventListener("click", () => {
      if (navItem.classList.contains("brands")) {
        const spSubmenu = document.querySelector("#fs-menu-drawer-store-sp-submenu");
        spSubmenu.dispatchEvent(new CustomEvent("show-brands"));
      }
      if (navItem.classList.contains("collections")) {
        const spSubmenu = document.querySelector("#fs-menu-drawer-store-sp-submenu");
        spSubmenu.dispatchEvent(new CustomEvent("show-collections"));
      }
    });
  });
};

/*
 * Main
 */

const menuDrawerStoreSpMain = () => {
  initializeMenuDrawerStoreSp();
};

addEventListener("DOMContentLoaded", (event) => {
  menuDrawerStoreSpMain();
});
